import { Component, OnInit } from '@angular/core';
import { SelectItem,TreeNode } from 'primeng/api';
import { FormBuilder, FormGroup } from '@angular/forms';




@Component({
  selector: 'app-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.css']
})
export class HelpComponent implements OnInit {
    ngOnInit() {}

}


// WEBPACK FOOTER //
// ./src/app/help/help.component.ts